"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAMESPACE_SEP = void 0;
var NAMESPACE_SEP = '/';
exports.NAMESPACE_SEP = NAMESPACE_SEP;